import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { iconLogoWhite } from "../../assets/icons/logo";
import { MenuItemProps } from "../../assets/menu/menuList";
import { BaseRoutes } from "../../routes/BaseRoutes";
import ItemMenu from "./ItemMenu";
import { useAccountDeletionsBadge } from "hooks/useAccountDeletionsBadge";
import { useSession } from "hooks/useSession";

import { MenuContainer, Content } from "./styles";

interface MenuProps {
  children: ReactNode;
  links: MenuItemProps[];
}

export const Menu: React.FC<MenuProps> = ({ children, links }) => {
  const { pathname } = useLocation();
  const { getUser } = useSession();
  const user = getUser();

  const isCurrentPath = (path: string) => {
    const checkURLCleared = path.split("/")[1];
    const baseURLCleared = pathname.split("/").splice(1)[0];

    return checkURLCleared === baseURLCleared;
  };

  const filteredLinks = links.filter((link) => {
    if (link.role) {
      return link.role.some((role) => user?.role.includes(role));
    }
    return true;
  });

  const showsAccountDeletions = filteredLinks.some(
    (link) => link.path === BaseRoutes.accountDeletions
  );
  const { pendingCount } = useAccountDeletionsBadge(showsAccountDeletions);

  const getBadgeCount = (link: MenuItemProps) =>
    link.path === BaseRoutes.accountDeletions ? pendingCount : undefined;

  const positionTopMenu = filteredLinks.filter(
    (link) => link.position === "top"
  );
  const positionBottomMenu = filteredLinks.filter(
    (link) => link.position === "bottom"
  );

  return (
    <>
      <MenuContainer>
        <div className="menu-logo">{iconLogoWhite}</div>

        <nav>
          <ul>
            {positionTopMenu.map((link) => (
              <ItemMenu
                key={link.path}
                name={link.label}
                isActive={isCurrentPath(link.path)}
                urlImg={
                  isCurrentPath(link.path) ? link.iconSelected : link.icon
                }
                urlImgHover={link.iconSelected}
                path={link.path}
                badgeCount={getBadgeCount(link)}
              />
            ))}
          </ul>
          <ul className="nav-ul-divider" />
          <ul>
            {positionBottomMenu.map((link) => (
              <ItemMenu
                key={link.path}
                name={link.label}
                isActive={isCurrentPath(link.path)}
                urlImg={
                  isCurrentPath(link.path) ? link.iconSelected : link.icon
                }
                urlImgHover={link.iconSelected}
                path={link.path}
                badgeCount={getBadgeCount(link)}
              />
            ))}
          </ul>
        </nav>
      </MenuContainer>

      <Content>{children}</Content>
    </>
  );
};
